import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@mui/material';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCustomerTypes } from '@sophocles/features/reference';

const CustomerTypeSelect = ({
  required = false,
  name,
  size = 'small',
  value,
  error,
  helperText,
  onChange,
  onBlur,
  sx,
  variant = 'filled',
  hiddenLabel = false,
}) => {
  const customerTypes = useSelector(selectCustomerTypes);

  // A retired type stays selectable only on a record already assigned it, so
  // editing an existing customer doesn't silently blank its type.
  const options = useMemo(
    () => customerTypes.filter(type => type.is_active || String(type.id) === String(value)),
    [customerTypes, value],
  );

  return (
    <FormControl fullWidth required={required} size={size} error={error} variant={variant} hiddenLabel={hiddenLabel}>
      {!hiddenLabel ? <InputLabel id="customer-type-select-label">Customer Type</InputLabel> : null}
      <Select
        labelId="customer-type-select-label"
        name={name}
        required={required}
        value={value}
        size={size}
        onChange={onChange}
        onBlur={onBlur}
        error={error}
        label={hiddenLabel ? undefined : 'Customer Type'}
        sx={sx ?? {}}
      >
        {options.map(type => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CustomerTypeSelect;
